import React from 'react';
import { PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import { saveAs } from 'file-saver';

const ExportPdfButton = ({ reportData }) => {
  const generatePdf = async () => {
    // Create a new PDF document
    const pdfDoc = await PDFDocument.create();
    const page = pdfDoc.addPage();
    const { width, height } = page.getSize();
    const fontSize = 12;
    const margin = 50;
    const tableTop = height - 100;
    const cellPadding = 5;
    let yPos = tableTop;

    // Load a font
    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);

    // Helper function to draw cell borders
    const drawCellBorder = (x, y, width, height) => {
      page.drawRectangle({
        x,
        y,
        width,
        height,
        borderColor: rgb(0, 0, 0),
        borderWidth: 1,
      });
    };

    // Draw the table header
    const headers = ['Part Name', 'Part Number', 'Operation Name', 'Operation Number'];
    const dataHeaders = [reportData.Item, 'Data', 'Data', 'Data'];
    const numCols = headers.length;
    const cellWidth = (width - 2 * margin) / numCols;

    // Draw table headers
    headers.forEach((header, i) => {
      const x = margin + i * cellWidth;
      page.drawText(header, {
        x: x + cellPadding,
        y: yPos - fontSize,
        size: fontSize,
        font: font,
        color: rgb(0, 0, 0),
      });
      drawCellBorder(x, yPos - fontSize - cellPadding, cellWidth, fontSize + 2 * cellPadding);
    });

    yPos -= fontSize + 2 * cellPadding;

    // Draw data headers
    dataHeaders.forEach((data, i) => {
      const x = margin + i * cellWidth;
      page.drawText(data, {
        x: x + cellPadding,
        y: yPos - fontSize,
        size: fontSize,
        font: font,
        color: rgb(0, 0, 0),
      });
      drawCellBorder(x, yPos - fontSize - cellPadding, cellWidth, fontSize + 2 * cellPadding);
    });

    yPos -= fontSize + 2 * cellPadding;

    // Table content headers
    const contentHeaders = ['Sr. no.', 'Specification', 'Methods of Inspection', 'Observation', 'Signature'];
    const contentNumCols = contentHeaders.length;
    const contentCellWidth = (width - 2 * margin) / contentNumCols;

    // Draw content headers
    contentHeaders.forEach((header, i) => {
      const x = margin + i * contentCellWidth;
      page.drawText(header, {
        x: x + cellPadding,
        y: yPos - fontSize,
        size: fontSize,
        font: font,
        color: rgb(0, 0, 0),
      });
      drawCellBorder(x, yPos - fontSize - cellPadding, contentCellWidth, fontSize + 2 * cellPadding);
    });

    yPos -= fontSize + 2 * cellPadding;

    // Draw rows
    reportData.Checksheet.forEach((item, idx) => {
      const cells = [
        idx + 1,
        item.checkpoint,
        item.StandardType,
        'observation value',
        'Signature',
      ];

      cells.forEach((cell, i) => {
        const x = margin + i * contentCellWidth;
        page.drawText(cell.toString(), {
          x: x + cellPadding,
          y: yPos - fontSize,
          size: fontSize,
          font: font,
          color: rgb(0, 0, 0),
        });
        drawCellBorder(x, yPos - fontSize - cellPadding, contentCellWidth, fontSize + 2 * cellPadding);
      });

      yPos -= fontSize + 2 * cellPadding;
    });

    // Serialize the PDF document to bytes (a Uint8Array)
    const pdfBytes = await pdfDoc.save();

    // Trigger the browser to download the PDF document
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    saveAs(blob, 'inspection_report.pdf');
  };

  return <button onClick={generatePdf}>Export to PDF</button>;
};

export default ExportPdfButton;
